import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  pendingSubscriptionController: [
    'runtimeConstant',
    '$scope',
    'signCertificataService',
    '$filter',
    'authService',
    function (
      runtimeConstant,
      $scope,
      signCertificataService,
      $filter,
      authService
    ) {
      'use strict';

      function getSignatories() {
        signCertificataService.getSignatoriesCertificata().then(function (data) {
          $scope.signatories = data;
          $scope.signatories.unshift({ PartName: '-- Todos --', Email: null });
          $scope.selectedSignatoryValue = $scope.signatories[0];
        });
      }

      function getPendingSigns(email, phone) {
        signCertificataService
          .getPendingSignsCertificata(email, phone)
          .then(function (data) {
            $scope.pendingSigns = data;

            if ($scope.pendingSigns.length > 0) {
              $scope.showNotification(
                'success',
                'Sua pesquisa retornou: ' + $scope.pendingSigns.length + ' itens.'
              );
            } else {
              $scope.showNotification(
                'warning',
                'Sua pesquisa não retornou itens.'
              );
            }
          });
      }

      function generate() {
        var signatory = $scope.selectedSignatoryValue;

        var email = signatory && signatory.Email
          ? signatory.Email
          : null;

        var phone = signatory && signatory.Phone
          ? signatory.Phone
          : null;

        getPendingSigns(email, phone);
      }

      function selectedSignatory(value) {
        if (arguments.length === 0) return $scope.selectedSignatoryValue;
        $scope.selectedSignatoryValue = value;
      }

      function getLink(idSignatureCertificata) {
        var item = $scope.pendingSigns.find(function (i) {
          return i.Id === idSignatureCertificata;
        });
        if (item) item.loadingLink = true;

        signCertificataService
          .getLinkSignersCertificata(idSignatureCertificata)
          .then(function (res) {
            swal.fire({
              title: $filter('translate')('SIGN LINK'),
              html:
                '<input id="signLinkInput" type="text" class="form-control" value="' +
                res.Link +
                '" readonly onclick="this.select()">',
              showConfirmButton: true,
              confirmButtonText: $filter('translate')('COPY'),
              showCancelButton: true,
              cancelButtonText: $filter('translate')('CLOSE'),
            }).then(function (result) {
              if (result.isConfirmed) {
                navigator.clipboard.writeText(res.Link);
                toastr.success('Link copiado!');
              }
            });
          })
          .catch(function () {
            toastr.error('Não foi possível obter o link de assinatura.');
          })
          .finally(function () {
            if (item) item.loadingLink = false;
          });
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function run() {
        try {
          $scope.signatories = null;
          $scope.pendingSigns = -1;
          $scope.selectedSignatoryValue = null;

          $scope.getSignatories = logWrapper(
            getSignatories,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getPendingSigns = logWrapper(
            getPendingSigns,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generate = logWrapper(
            generate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedSignatory = logWrapper(
            selectedSignatory,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLink = logWrapper(
            getLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );

          getSignatories();
          getPendingSigns(null);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};